(() => {
  if (customElements.get('quiz-results')) {
    return;
  }

  class QuizResults extends HTMLElement {
    constructor() {
      super();

      this.recommendedProducts = this.parseData('.product-data-recommendation');
      this.mayLikeProducts = this.parseData('.product-data-may-like');
      this.title = this.getAttribute('data-title') || '';
      this.description = this.getAttribute('data-desc') || '';
      this.listid = this.getAttribute('data-listid') || '';
      this.companyid = this.getAttribute('data-companyid') || '';
      this.subscribe = this.getAttribute('data-subscribe') || '';

      this.url = new URLSearchParams(window.location.search)
      this.email = this.url.get('email') || '';
      this.firstName = this.url.get('firstName') || '';
      this.country = this.getAttribute('data-country') || 'US';
      this.marketing = this.url.get('marketing') === 'yes';
    }

    connectedCallback() {
      this.handleSubscribe();
      this.handleShare();
      this.removeEmailFromUrl();
    }

    removeEmailFromUrl() {
      const url = new URL(window.location.href);
      url.searchParams.delete('email');
      window.history.replaceState({}, document.title, url.toString());
    }

    async handleSubscribe() {
      if(!this.marketing) {
        return;
      }

      const options = {
        method: 'POST',
        headers: {revision: '2024-07-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    location: {
                      country: this.country,
                    },
                    email: this.email
                  },
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: this.listid}}}
          }
        })
      };
      try {
        fetch(this.subscribe, options);
      } catch (error) {
        console.error('Subscription error:', error);
      }
    }

    handleShare() {
      if(!this.email) {
        return;
      }

      const payload = {
        email: this.email,
        title: this.title,
        desc: this.description,
        firstName: this.firstName,
        reco: this.recommendedProducts,
        may_like: this.mayLikeProducts,
      }

      fetch('/apps/manuka-app/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
    }

    parseData(selector) {
      return Array.from(this.querySelectorAll(selector))
        .map((el) => this.parseProductData(el))
        .filter(Boolean);
    }

    parseProductData(element) {
      const raw = element.textContent.trim();
      if (!raw) return null;

      try {
        return JSON.parse(raw);
      } catch (jsonError) {
        try {
          return new Function(`"use strict"; return (${raw});`)();
        } catch (fallbackError) {
          console.warn('quiz-results: unable to parse product data', {
            element,
            jsonError,
            fallbackError,
          });
          return null;
        }
      }
    }
  }

  customElements.define('quiz-results', QuizResults);
})();
